/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a.empty[_ngcontent-%COMP%], a.empty[_ngcontent-%COMP%]:hover{color:#d3d3d3!important;cursor:default}a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:hover{color:green!important;width:100%}.make-gold[_ngcontent-%COMP%], .make-gold[_ngcontent-%COMP%]:hover{background-color:gold}agm-map[_ngcontent-%COMP%]{height:70vh}"];
export { styles as styles };
